define("shared/helpers/concat-classes", ["exports", "@ember/component/helper", "@ember/debug"], function (_exports, _helper, _debug) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/component/helper",0,"@ember/debug"eaimeta@70e063a35619d71f
  /**
   * @module Helpers
   */
  /**
   * @class ConcatClassesHelpers
   * @extends Helpers
   */
  /**
   * Concatenates all classes with a space
   * such that the class attribute is properly applied
   *
   * @method concat-classes
   *
   */
  function concatClasses(arrayOfClasses) {
    (false && !(Array.isArray(arrayOfClasses)) && (0, _debug.assert)('concat-classes requires an array of classes', Array.isArray(arrayOfClasses)));
    return arrayOfClasses.filter(Boolean).join(' ');
  }
  const concatClassesHelper = (0, _helper.helper)(concatClasses);
  var _default = _exports.default = concatClassesHelper;
});